import type { PropsWithChildren } from 'react'

export const AsideActionsItems = ({ children }: PropsWithChildren) => {
  return <>{children}</>
}
